import { WizardStep } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { CheckAvailabilityDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'
import { DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

import { absencesStep } from './AbsencesStep'
import { businessUnitsStep } from './BusinessUnitsStep'
import { companyStep } from './CompanyStep'
import { departmentsStep } from './DepartmentsStep'
import { salaryTypesStep } from './SalaryTypesStep'

export const useDatevLaudsSteps = () => {
  const { company } = useCurrentSession()
  const { data: featuresData } = useQuery(CheckAvailabilityDocument, {
    variables: { companyId: company.id },
  })

  const moduleAvailabilities = featuresData?.companies?.moduleAvailabilitiesConnection?.nodes || []

  const compensationsEnabled = isModuleAvailabilityEnabled(
    moduleAvailabilities,
    AvailableModules.compensations
  )

  const laudsSteps: (() => WizardStep<DatevWizardData>)[] = [
    companyStep,
    businessUnitsStep,
    ...(compensationsEnabled ? [salaryTypesStep] : []),
    absencesStep,
    departmentsStep,
  ]

  return laudsSteps
}
